import React, { useMemo } from "react";
import { sanitizeHtml } from "../../helpers/utils";
import {Tooltip} from "@fluentui/react-components";
import "./SafeHtml.scss";

export default ({ html, className, style }) => {
  const cleanHtml = useMemo(() => sanitizeHtml(html), [html]);
  
  // Check if HTML contains list elements
  const hasListElements = useMemo(() => {
    return /<(ul|ol|li)/i.test(cleanHtml);
  }, [cleanHtml]);

  const content = (
    <div
      className={`table-safe-html ${className}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
      aria-label="c-safe-html"
    />
  );

  // Don't wrap with tooltip if it contains lists
  if (hasListElements) {
    return content;
  }

  return (
    <Tooltip
      withArrow
      positioning="top"
      content={{
        children: (
          <div
            dangerouslySetInnerHTML={{ __html: cleanHtml }}
            aria-label="c-safe-html"
          />
        ),
        className: "ListingTooltip",
      }}
      relationship="description"
    >
      {content}
    </Tooltip>
  );
};